(ns api.stock.leadtime
  "Customer-facing dispatch range for supplier lead times.")

;; Short lead-times get a small buffer; long ones get a 33% buffer to
;; absorb supplier variability.
(def long-threshold-days 7)
;; Past this, quote the range in weeks (industry standard for furniture and
;; made-to-order goods).
(def weeks-threshold-days 21)

(defn max-days
  "Pad lead-time conservatively for the dispatch ETA shown to customers."
  [lead-time]
  (long
    (Math/ceil
      (double
        (if (> lead-time long-threshold-days)
          (+ lead-time (/ lead-time 3))
          (+ lead-time 2))))))

(defn weeks? [lead-time]
  (and lead-time (> lead-time weeks-threshold-days)))

(defn weeks-range
  "\"6 to 8 weeks\" for a 42 to 56 day range."
  [lead-time max-days]
  (let [lo (long (Math/floor (/ (double lead-time) 7)))
        hi (max (inc lo) (long (Math/ceil (/ (double max-days) 7))))]
    (str lo " to " hi " weeks")))

(defn range-text
  "Weeks past the threshold, else \"3 to 5 working days\"."
  ([lead-time max-days]
   (range-text lead-time max-days "working days"))
  ([lead-time max-days day-unit]
   (if (weeks? lead-time)
     (weeks-range lead-time max-days)
     (str lead-time " to " max-days " " day-unit))))
